

















import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { StaffEntity } from '@/entities/staff.entity';
import PointTimer from '@/components/Layout/Layouts/PointTimer.vue';

@Component<PointInformationCard>({
  components: { PointTimer },
  computed: {
    ...mapGetters('staff', ['currentStaff']),
  },
})
export default class PointInformationCard extends Vue {
  currentStaff!: StaffEntity;
}
